"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64ToBlob = ({ base64String, contentType = "image/png", }) => {
    const byteCharacters = atob(base64String.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
};
//# sourceMappingURL=base64-to-blob.js.map